// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_1EdaundcIYpyy1dCOevOJ_","body":"_3o-huLLomRYVwDgiYIKdw8","header":"_1-yGC1mOQHFnoeYfqZmrF6","title":"_1LDec89Xs4yh3NwA5giYw5","subTitle":"UyYLWmClyze4B9ja5Usl7"};